module.exports = __webpack_public_path__ + "static/media/Inicio.6324e7bf.png";